import React, { useEffect, useState } from "react";
import NoData from "../../assets/admin/NoData.svg";

const EmptyTableRecord = () => {
  const [isIconLoaded, setIsIconLoaded] = useState(false);

  useEffect(() => {
    const preloadedImage = new Image();
    preloadedImage.src = NoData;

    if (preloadedImage.complete) {
      setIsIconLoaded(true);
      return;
    }

    preloadedImage.onload = () => setIsIconLoaded(true);
    preloadedImage.onerror = () => setIsIconLoaded(true);
  }, []);

  return (
    <div className="text-center space-y-4 py-6">
      <div className="relative mx-auto h-22 w-22">
        {!isIconLoaded && (
          <div className="absolute inset-0 animate-pulse rounded-md bg-gray-200" />
        )}
        <img
          src={NoData}
          alt="Bereload Nodata"
          className={`mx-auto h-22 w-22 transition-opacity duration-200 ${
            isIconLoaded ? "opacity-100" : "opacity-0"
          }`}
          loading="eager"
          fetchPriority="high"
          decoding="sync"
        />
      </div>
      {isIconLoaded && (
        <span className="text-gray-700 font-medium text-sm ">
          No data to display.
        </span>
      )}
    </div>
  );
};

export default EmptyTableRecord;
